module.exports = __webpack_public_path__ + "img/logo-limeroad.d2fbc7e4.png";